module.exports = __webpack_public_path__ + "static/media/aws.40ffd67a.svg";